import {
  defaultColumnSizingOptions,
  getColumnsDef,
} from "components/ManageBenefitCategories/IncludedCategoriesTable/columns";
import { ManageBenefitCategories } from "components/ManageBenefitCategories/ManageBenefitCategories";

import { Analytics } from "components/Analytics/Analytics";
import { PageSkeleton } from "components/Skeletons/PageSkeleton";
import { PageContent } from "components/styled";
import { useRoleType } from "hooks/useRoleType";
import { useAtom, useAtomValue } from "jotai";
import { columnNames } from "library/constants";
import { EAdminTabView } from "library/types";
import { useCallback, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetBenefitCategories } from "state/queries/useGetBenefitCategories";
import { selectedAdminTabState } from "store";
import {
  filteredBenefitCategoriesState,
  searchFilterValueState,
} from "store/UIAdminPage";
import { Subheader } from "../../components/Subheader/Subheader";
import { AdminPageToolbar } from "./components/AdminPageToolbar";
import { AppSpinner } from "components/AppSpinner/AppSpinner";

export function AdminPage() {
  const { t } = useTranslation();
  const selectedTab = useAtomValue(selectedAdminTabState);
  const roles = useRoleType();
  const isReadOnlyUser = roles?.hasReadOnlyRole;

  const [benefitCategories, setBenefitCategories] = useAtom(
    filteredBenefitCategoriesState
  );

  const [searchFilterValue, setSearchFilterValue] = useAtom(
    searchFilterValueState
  );

  const {
    data: benefitCategoriesRes,
    isLoading,
    isRefetching,
  } = useGetBenefitCategories({
    countryCode: 0,
    clientInternalNumberGOS: 0,
  });

  const columnsDef = getColumnsDef({
    countryCode: 0,
    hasSelection: true,
    isReadOnlyUser,
    t,
  });

  const benefitTableItems = useMemo(() => {
    return benefitCategories
      ?.map((category) => {
        const formattedData = {
          ...category,
          coverPhoto: {
            name: category.backgroundPicturePath,
            base64String: category.backgroundPictureContent,
            type: category.backgroundPictureMimeType,
          },
          id: category.benefitCategoryTag,
          defaultState: {
            ...category,
            coverPhoto: {
              name: category.backgroundPicturePath,
              base64String: category.backgroundPictureContent,
              type: category.backgroundPictureMimeType,
            },
            id: category.benefitCategoryTag,
          },
        };
        // formattedData.defaultState = formattedData;
        return formattedData;
      })
      .sort((a, b) => a.benefitCategoryTag - b.benefitCategoryTag);
  }, [benefitCategories]);

  const handleSearchFilterValue = useCallback(
    (value) => {
      setSearchFilterValue(value);
    },
    [setSearchFilterValue]
  );

  useEffect(() => {
    if (!benefitCategoriesRes?.benefitCategories) return;
    setBenefitCategories(benefitCategoriesRes?.benefitCategories);
  }, [benefitCategoriesRes, setBenefitCategories]);

  const loading = isLoading || !benefitTableItems;

  if (loading) {
    return <PageSkeleton />;
  }

  return (
    <>
      {isRefetching && <AppSpinner />}
      <Subheader
        isAdminPage
        searchFilterValue={searchFilterValue}
        items={benefitCategories}
        setSearchFilterValue={handleSearchFilterValue}
      />
      <AdminPageToolbar
        searchFilterValue={searchFilterValue}
        searchActive={!!searchFilterValue}
        benefitCategories={benefitCategories}
      />
      {selectedTab === EAdminTabView.benefits && (
        <>
          <PageContent>
            <ManageBenefitCategories
              countryCode={0}
              searchFilterValue={searchFilterValue}
              benefitCategories={benefitCategories}
              benefitTableItems={benefitTableItems}
              defaultColumnSizingOptions={defaultColumnSizingOptions}
              columns={columnsDef}
              columnNames={columnNames}
              selectionMode={"single"}
            />
          </PageContent>
        </>
      )}
      {selectedTab === EAdminTabView.analytics && <Analytics />}
    </>
  );
}
